import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class BoatDetailsHover extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {}
    this.renderBoatDetails = this.renderBoatDetails.bind(this)
  }

  renderBoatDetails() {
    return (
      <div className="p-0">
        <a
          target="_blank"
          rel="noreferrer"
          href={this.props.editBoatPath}
          className="grid grid-cols-2 border-b-2 border-gray-300 bg-gray-100 px-6 py-4"
        >
          <h5 className="m-0 font-bold">{this.props.name}</h5>
          <p className="mb-0">Click for full record</p>
        </a>
        <div className="grid grid-cols-3 gap-2 px-6 pt-4">
          <div>
            <h5 className="font-bold">Type</h5>
            <p>{this.props.type}</p>
          </div>
          <div>
            <h5 className="font-bold">Make</h5>
            <p>{this.props.make}</p>
          </div>
          <div>
            <h5 className="font-bold">Length</h5>
            <p>{this.props.length}</p>
          </div>
          <div>
            <h5 className="font-bold">Beam</h5>
            <p>{this.props.beam}</p>
          </div>
          <div>
            <h5 className="font-bold">Draft</h5>
            <p>{this.props.draft}</p>
          </div>
          <div>
            <h5 className="font-bold">Height</h5>
            <p>{this.props.height}</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 px-6 pb-4">
          <div>
            <h5 className="font-bold">Registration</h5>
            {this.props.viewRegistrationDocUrl ? (
              <a
                className="pr-4"
                target="_blank"
                rel="noreferrer"
                href={this.props.viewRegistrationDocUrl}
              >
                {this.props.registration}
              </a>
            ) : (
              <p>{this.props.registration}</p>
            )}
          </div>
          <div className="col-start-3">
            <h5 className="font-bold">Exp</h5>
            <p>{this.props.registrationExp}</p>
          </div>
          <div>
            <h5 className="font-bold">Insurance</h5>
            {this.props.viewInsuranceDocUrl ? (
              <a
                className="pr-4"
                target="_blank"
                rel="noreferrer"
                href={this.props.viewInsuranceDocUrl}
              >
                {this.props.insuranceCompany}-{this.props.insuranceNumber}
              </a>
            ) : (
              <p>
                {this.props.insuranceCompany}-{this.props.insuranceNumber}
              </p>
            )}
          </div>
          <div className="col-start-3">
            <h5 className="font-bold">Exp</h5>
            <p>{this.props.insuranceExp}</p>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div
          className="my-3"
          onFocus={() => this.setState({ showDetails: true })}
          onBlur={() => this.setState({ showDetails: false })}
          onMouseEnter={() => this.setState({ showDetails: true })}
          onMouseLeave={() => this.setState({ showDetails: false })}
        >
          <a target="_blank" rel="noreferrer" href={this.props.editBoatPath}>
            Details
            <i className="icon icon-chevron-down" />
          </a>
          {this.state.showDetails && (
            <div className={"card absolute z-10 p-0 shadow-md"}>
              {this.renderBoatDetails()}
            </div>
          )}
        </div>
      </div>
    )
  }
}

BoatDetailsHover.propTypes = {
  editBoatPath: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  make: PropTypes.string,
  length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  beam: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  draft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  registration: PropTypes.string,
  registrationExp: PropTypes.string,
  viewRegistrationDocUrl: PropTypes.string,
  insuranceCompany: PropTypes.string,
  insuranceNumber: PropTypes.string,
  insuranceExp: PropTypes.string,
  viewInsuranceDocUrl: PropTypes.string,
}

export default BoatDetailsHover
